// tslint:disable-next-line
import * as React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';
import { localizedString } from '@locale/index';
import '@style/component/search-bar.less';

export interface NiSearchBarPropsInfo {
  style?: React.CSSProperties | undefined;
  onSearch?: (value: string) => void;
  icon?: JSX.Element;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  extra?: React.ReactNode;
}

export interface NiSearchBarStateInfo {
  value: string;
}

export class NiSearchBar extends React.Component<
  NiSearchBarPropsInfo,
  NiSearchBarStateInfo
> {
  constructor(props: NiSearchBarPropsInfo) {
    super(props);

    this.state = {
      value: props.value || ''
    };
  }

  onInputChanged = (value: string) => {
    if (this.state.value !== value) {
      this.setState({
        value
      }, () => {
        if (this.props.onChange) {
          this.props.onChange(value);
        }
      });
    }
  };

  onButtonClicked = () => {
    if (this.props.onSearch) {
      this.props.onSearch(this.state.value);
    }
  };

  render() {
    const { value } = this.state;
    const { icon, placeholder, extra, style } = this.props;

    return (
      <div className="search-bar">
        <Input
          size="large"
          prefix={icon || <SearchOutlined
            style={{ color: 'rgba(72, 72, 102, 0.4)' }}
            onClick={this.onButtonClicked}
          />}
          style={style}
          placeholder={placeholder || localizedString('common_search_placeholder')}
          value={value}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            this.onInputChanged(event.target.value)
          }
          onPressEnter={() => this.onButtonClicked()}
        />
        {
          extra
        }
      </div>
    );
  }
}
